import { render, staticRenderFns } from "./DetailComponent.vue?vue&type=template&id=39697d2a&scoped=true&"
import script from "./DetailComponent.vue?vue&type=script&lang=js&"
export * from "./DetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./DetailComponent.vue?vue&type=style&index=0&id=39697d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39697d2a",
  null
  
)

export default component.exports